<template>
  <div class="waves">
    <img src="../../assets/imgs/music-notes/sound-line-01.png" ref="wave01" class="wave-01" />
    <img src="../../assets/imgs/music-notes/sound-line-02.png" ref="wave02" class="wave-02" />
    <img src="../../assets/imgs/music-notes/sound-line-03.png" ref="wave03" class="wave-03" />
  </div>
</template>

<script>
import gsap from 'gsap';

export default {
  name: "SoundWaves",
  data() {
    return {
      lang: []
    }
  },
  mounted() {
    this.startWaves();
  },
	methods: {
		startWaves() {
      var note1 = gsap.timeline({repeat: -1});
      note1.set(this.$refs.wave01, { x: 0, y: 0, opacity: 0.7});
      note1.to(this.$refs.wave01, { x: 15, y: 5, opacity: 1, duration: 1, ease: "power2.out"});      
      note1.to(this.$refs.wave01, { x: 0, y: 0, opacity: 0.75, duration: 1, ease: "power2.in"});      

      var note2 = gsap.timeline({repeat: -1});
      note2.set(this.$refs.wave02, { x: 0, y: 0, opacity: 0.75});
      note2.to(this.$refs.wave02, { x: 10, y: 2, opacity: 1, duration: 1, ease: "power2.in"});      
      note2.to(this.$refs.wave02, { x: 0, y: 0, opacity: 0.7, duration: 1, ease: "power2.out"});      

      var note3 = gsap.timeline({repeat: -1});
      note3.set(this.$refs.wave03, { x: 0, y: 0, opacity: 0.7});
      note3.to(this.$refs.wave03, { x: 10, y: 2, opacity: 1, duration: 1, ease: "power2.in"});      
      note3.to(this.$refs.wave03, { x: 0, y: 0, opacity: 0.7, duration: 1, ease: "power2.out"});      

		}
	}
}
</script>
<style scoped lang="scss">
.waves {
  .wave-01 {
    transform: translate(0, 200px);
  }
  .wave-02 {
    transform: translate(0, 100px);
  }
  .wave-03 {
    transform: translate(0, 80px), scale(0.5);
  }
}
</style>
